/*
 * Models for storing cancel action labels in all locales
 */
define([
  "backbone",
  "underscore",
  "jquery",
  "messaging/messenger",
  "configuration/properties",
], function (Backbone, _, $, Messenger, Properties) {
  const CancelActionLabelsModel = {};

  CancelActionLabelsModel.cancelActionLabel = Backbone.Model.extend({
    idAttribute: "localeId",
    defaults: {
      labelText: "",
      localeId: 0,
      localeName: "",
      touchPointId: 0,
    },
    parse: function (response) {
      return response;
    },
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return (
        Properties.rootURL +
        "/" +
        kbId +
        "/admin/labels/cancelAction/touchPoint/" +
        this.get("touchPointId") +
        "/locale/" +
        this.get("localeId")
      );
    },
    validateAttribute: function (attribute, value) {
      if (attribute === "labelText") {
        return this.validateRequiredValue(value, { maxLength: 255 });
      }
    },
  });

  CancelActionLabelsModel.cancelActionLabels = Backbone.Collection.extend({
    model: CancelActionLabelsModel.cancelActionLabel,
    comparator: "localeName",
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return (
        Properties.rootURL +
        "/" +
        kbId +
        "/admin/labels/cancelAction/touchPoint/" +
        this.touchPointId
      );
    },
  });

  Messenger.reqres.setHandler(
    "cancelAction:labels",
    function (touchPointId) {
      const labels = new CancelActionLabelsModel.cancelActionLabels();
      labels.touchPointId = touchPointId;
      labels.fetch();
      return labels;
    },
    this,
  );

  return CancelActionLabelsModel;
});
